import { render, staticRenderFns } from "./AddIndependentLesson.vue?vue&type=template&id=ba818a4a"
import script from "./AddIndependentLesson.vue?vue&type=script&lang=js"
export * from "./AddIndependentLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports